const containerButtons = ['flex', 'justify-center', 'gap-3'].join(' ');

export { containerButtons };
